import { CommonModule } from '@angular/common';
import { Component, DestroyRef, ChangeDetectorRef, Inject, HostBinding } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { Constante } from '../../../constante';
import { AppService } from '../../../core/services/app-service';
import { MenuAs, perfilAs } from '../../../core/models/interface/auth';
import { UsuarioAS } from '../../../core/models/usuarioas';
import { AppUtil } from '../../../core/utility/app-util';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take, switchMap, of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { SecurityService } from '../../../core/services/security-service';
import { SecurityUtil } from '../../../core/utility/security-util';
import { NavigationItem } from '../../../core/models/navigation-item';
import { ConfirmationDialog } from '../../../shared/dialogs/confirmation-dialog/confirmation-dialog';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AuthService } from '../../../core/services/auth/auth.service';
import { RoleSelectorDialog, InstitutionSelectorDialog } from './selectors.dialog';
import { AuthUtility } from '../../../core/utility/auth-utility';
import { Role, Institution } from '../../../core/models/auth/perfil';
import { NotificacionesService, NotificacionInbox } from '../../../services/notificaciones/notificaciones.service';
import { EstudianteService } from '../../../services/estudiante/estudiante.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-header',
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatDividerModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './header.html',
    styleUrls: ['./header.scss']
})
export class Header {
    _const = Constante;
    isProduction = environment.production;
    @HostBinding('class.non-production-header') get isNonProd() { return !this.isProduction; }
    unreadCountNotifi: number = 0;
    unreadCountMessage: number = 0;

    inboxNotificaciones: NotificacionInbox[] = [];
    isLoadingNotificaciones = false;

    showAvatar: boolean = true;
    userPhoto: string | null = null;

    perfilActive: perfilAs | null = null
    perfilesInactivos: perfilAs[] | null = null
    dataPerfiles: any
    dataUser: UsuarioAS | null

    constructor(
        private _appService: AppService,
        private _router: Router,
        private destroyRef: DestroyRef,
        private toastService: ToastrService,
        private dialog: MatDialog,
        private authService: AuthService,
        private notificacionesService: NotificacionesService,
        private cdr: ChangeDetectorRef,
        private estudianteService: EstudianteService
    ) {
        this.dataUser = AuthUtility.getValueUserAS();
        this.loadUserMenuData();
        this.loadNotifications();
        this.loadUserPhoto();

        // Legacy menu logic
        if (AppUtil.getMenus()?.length == 0) {
            // this.obtenerMenus() 
        }

        // else
        //     this.obtenerListaPerfiles()
    }

    onCambioPerfil(item: perfilAs) {
        this.obtenerNuevoToken(item)
    }
    onToggleNavigation() {
        this._appService.toggleSidebar();
    }



    signOut() {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            width: '420px',
            panelClass: ['confirm-dialog-modern'],
            disableClose: true,
            hasBackdrop: true,
            data: {
                title: 'Confirmar cierre de sesión',
                message: `¿Está seguro de cerrar su sesión? Esto también cerrara su sesión de la suite`,
                confirmText: 'Salir',
                cancelText: 'Cancelar'
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            //console.log(result)
            if (result && result.status == this._const.DIALOG_STATUS_OK) {
                this._appService.goSignOut()
                // this.eliminarUsuario(itemid.usuario_id)
            }
        });
    }
    onVerPerfil() {
        this._router.navigate(['/perfil']);
    }

    onVerTodasNotificaciones() {
        this._router.navigate(['/notificaciones/recibidas']);
    }

    // Role-based Menu restrictions
    get showMiPerfil(): boolean {
        const p = this.dataUser?.cPerfil?.toUpperCase() || '';
        return p !== 'AUXI-BOT';
    }

    get showCambiarInstitucion(): boolean {
        const p = this.dataUser?.cPerfil?.toUpperCase() || '';
        return ['PADRE', 'AUXILIAR', 'DOCENTE', 'DIRECTIVO', 'ADMINISTRADOR', 'SUPER USER'].includes(p);
    }

    get showCerrarSesion(): boolean {
        const p = this.dataUser?.cPerfil?.toUpperCase() || '';
        return p !== 'AUXI-BOT';
    }

    headerMenuGroups: { inst: Institution, roles: Role[] }[] = [];
    isLoadingHeaderMenu = false;
    expandedInstitutionId: string | null = null;

    toggleInstitution(instId: string, event: Event) {
        event.stopPropagation();
        if (this.expandedInstitutionId === instId) {
            this.expandedInstitutionId = null;
        } else {
            this.expandedInstitutionId = instId;
        }
    }

    setExpandedCurrentInst() {
        this.expandedInstitutionId = null;
    }



    loadUserMenuData() {
        if (!this.dataUser) return;
        if (this.dataUser.cPerfil === 'AUXI-BOT') return;
        if (this.headerMenuGroups.length > 0) return; // Ya se cargó

        this.isLoadingHeaderMenu = true;
        this.authService.listarInstituciones(this.dataUser.idUsuario).subscribe({
            next: (instRes) => {
                if (instRes.success === 1 && instRes.data && instRes.data.length > 0) {
                    let pending = instRes.data.length;
                    const groups: { inst: Institution, roles: Role[] }[] = [];

                    instRes.data.forEach(inst => {
                        this.authService.listarRoles(this.dataUser!.idUsuario, inst.uuid).subscribe({
                            next: (roleRes) => {
                                const roles = (roleRes.success === 1 && roleRes.data) ? roleRes.data : [];
                                groups.push({ inst, roles });
                                pending--;
                                if (pending === 0) {
                                    this.headerMenuGroups = groups;
                                    this.isLoadingHeaderMenu = false;
                                    this.setExpandedCurrentInst();
                                    this.cdr.detectChanges();
                                }
                            },
                            error: () => {
                                groups.push({ inst, roles: [] });
                                pending--;
                                if (pending === 0) {
                                    this.headerMenuGroups = groups;
                                    this.isLoadingHeaderMenu = false;
                                    this.setExpandedCurrentInst();
                                    this.cdr.detectChanges();
                                }
                            }
                        });
                    });
                } else {
                    this.isLoadingHeaderMenu = false;
                    this.cdr.detectChanges();
                }
            },
            error: () => {
                this.isLoadingHeaderMenu = false;
                this.cdr.detectChanges();
            }
        });
    }

    loadNotifications() {
        if (!this.dataUser) return;
        if (this.dataUser.cPerfil === 'AUXI-BOT') return;
        this.isLoadingNotificaciones = true;
        // Fetch up to 10 latest notifications
        this.notificacionesService.listarBandeja(0, 10).subscribe({
            next: (res) => {
                if (res.success === 1 && res.data) {
                    this.inboxNotificaciones = res.data.items || [];
                    // Assume estadoId 1 (CREADA) or 2 (ENVIADA) are unread for the recipient, 3 is LEIDA
                    this.unreadCountNotifi = this.inboxNotificaciones.filter(n => n.estadoId < 3).length;
                }
                this.isLoadingNotificaciones = false;
                this.cdr.detectChanges();
            },
            error: (err) => {
                console.error('Error loading notifications', err);
                this.isLoadingNotificaciones = false;
                this.cdr.detectChanges();
            }
        });
    }

    private loadUserPhoto() {
        if (this.dataUser && this.dataUser.cPerfil === 'AUXI-BOT') return;

        const payload = AuthUtility.getValidTokenPayload();
        const personId = payload?.person_id || payload?.personId;
        if (!personId) {
            this.showAvatar = false;
            return;
        }

        this.estudianteService.getPersonPhoto(personId).subscribe({
            next: (photo) => {
                this.userPhoto = photo;
                this.showAvatar = !!photo;
                this.cdr.detectChanges();
            },
            error: () => {
                this.userPhoto = null;
                this.showAvatar = false;
                this.cdr.detectChanges();
            }
        });
    }

    onNotificationClick(notificacion: NotificacionInbox, event: Event) {
        event.stopPropagation();
        // Ensure we unmark reading locally if possible before or after backend sync.
        if (notificacion.estadoId < 3) {
            this.notificacionesService.marcarLeida(notificacion.id).subscribe({
                next: (res) => {
                    if (res.success === 1) {
                        notificacion.estadoId = 3;
                        notificacion.estadoNombre = 'LEIDA';
                        this.unreadCountNotifi = Math.max(0, this.unreadCountNotifi - 1);
                        this.cdr.detectChanges();
                    }
                }
            });
        }

        // Open the detail dialog
        this.dialog.open(NotificationInboxDetailDialog, {
            width: '550px',
            maxWidth: '90vw',
            panelClass: ['rounded-2xl'],
            data: { notificacion }
        });
    }

    formatShortName(fullName?: string): string {
        if (!fullName) return '';
        const parts = fullName.trim().split(/\s+/);
        if (parts.length >= 4) {
            return `${parts[0]} ${parts[2]}`;
        } else if (parts.length === 3) {
            return `${parts[0]} ${parts[1]}`;
        } else if (parts.length > 0) {
            return parts.slice(0, 2).join(' ');
        }
        return fullName;
    }

    onSelectHeaderRole(institutionId: string, roleId: string) {
        this.authService.changeToken(institutionId, roleId).subscribe({
            next: (res) => {
                if (res.success === 1 && res.data && res.data.token) {
                    this.toastService.success('Cambiando de institución y rol...', 'Éxito');
                    AuthUtility.initSessionData(res.data.token);

                    // Buscar nombres amigables de la lista previamente consultada y actualizar el usuario
                    const instGroup = this.headerMenuGroups.find(g => g.inst.uuid === institutionId);
                    if (instGroup && this.dataUser) {
                        const roleObj = instGroup.roles.find(r => r.uuid === roleId);
                        if (roleObj) {
                            this.dataUser.cPerfil = roleObj.name;
                            this.dataUser.roleId = roleObj.uuid;
                            this.dataUser.cInstitucion = instGroup.inst.name;
                            this.dataUser.institutionId = instGroup.inst.uuid;
                            AuthUtility.setValueUserAS(this.dataUser);
                        }
                    }

                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                } else {
                    const errorMsg = res.errors && res.errors.length > 0 ? res.errors[0].message : (res.message || 'No se pudo generar nuevo acceso');
                    this.toastService.warning(errorMsg, 'Atención');
                }
            },
            error: (err) => {
                const message = err.error?.errors?.[0]?.message || err.error?.message || err.message || 'Error al cambiar institución';
                this.toastService.error(message, 'Error');
            }
        });
    }

    obtenerNuevoToken(perfil: perfilAs) {
    }
    obtenerListaPerfiles() {

    }

    obtenerMenus() {

    }

    formarMenus(data: MenuAs[]) {
        const _menuHome = new NavigationItem();
        _menuHome.id = "0";
        _menuHome.type = "basic";
        _menuHome.title = "Inicio";
        _menuHome.link = "/inicio";
        //_menuHome.active = true;
        _menuHome.icon = 'heroicons_outline:home';

        const menus: NavigationItem[] = data.map(item => {
            const navItem = new NavigationItem();
            navItem.id = item.idMenu.toString();
            navItem.type = item.idMenuPadre == 0 ? 'basic' : 'group';
            navItem.title = item.cMenu;
            navItem.link = item.cUrl;
            navItem.icon = item.cIcon;
            return navItem;
        });
        const _groupDashboard = new NavigationItem();
        _groupDashboard.id = "14";  //**** se debe cambiar por number, esta como texto */
        _groupDashboard.type = "group";
        _groupDashboard.title = "Modulo Dashboard";
        // _groupDashboard.subtitle = "Unique dashboard designs";

        _groupDashboard.children = [
            _menuHome
        ];

        _groupDashboard.children = _groupDashboard.children.concat(menus)
        this._appService.setMenus(_groupDashboard, data)
        this._router.navigate([''])

        // this.menu = [_groupDashboard];
    }
    onActualizarCatalogos() {
        // this.catalogosService.syncCatalogos().subscribe(() => {
        //     this.toastService.info("Se actualizaron los catálogos", this._const.MESSAGE_TITLE_INFO,)
        // });
    }
}

@Component({
    selector: 'app-notification-detail-dialog',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatIconModule, MatDialogModule],
    template: `
        <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100/60 bg-white">
            <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600">
                    <mat-icon svgIcon="heroicons_outline:bell" class="icon-sm"></mat-icon>
                </div>
                <div class="flex flex-col">
                    <span class="text-[0.65rem] font-bold text-gray-500 uppercase tracking-widest">{{data.notificacion.tipoNombre || 'Notificación'}}</span>
                    <h2 class="text-sm font-bold text-gray-900 leading-none mt-0.5">{{data.notificacion.titulo}}</h2>
                </div>
            </div>
            <button mat-icon-button (click)="dialogRef.close()" class="!w-8 !h-8 !leading-none text-gray-400 hover:text-gray-600 bg-gray-50/50 hover:bg-gray-100">
                <mat-icon class="icon-sm">close</mat-icon>
            </button>
        </div>
        
        <div class="px-6 py-5 bg-slate-50/30">
            <!-- Emisor -->
            <div class="flex items-center gap-3 mb-5 p-3 rounded-xl bg-white border border-gray-100 shadow-sm">
                <div class="w-10 h-10 rounded-full bg-slate-100 text-slate-700 font-bold flex items-center justify-center text-lg border border-slate-200">
                    {{(data.notificacion.remitente?.nombreCompleto?.charAt(0) || 'A') | uppercase}}
                </div>
                <div class="flex flex-col flex-1 min-w-0">
                    <div class="flex items-center justify-between">
                        <span class="text-[13px] font-bold text-gray-800 truncate">{{data.notificacion.remitente?.nombreCompleto | titlecase}}</span>
                    </div>
                    <span class="text-xs text-gray-500 truncate">{{data.notificacion.remitente?.roleName}}</span>
                </div>
            </div>

            <!-- Contenido -->
            <div class="bg-white p-5 rounded-xl border border-gray-100/80 shadow-sm mb-4">
                <p class="text-[13px] text-gray-700 whitespace-pre-line leading-relaxed">{{data.notificacion.cuerpo}}</p>
            </div>

            <!-- Metadatos (Opcional) -->
            <div class="flex items-center justify-between text-xs text-gray-400 font-medium px-2">
                <span class="flex items-center gap-1.5"><mat-icon class="!text-[14px] !w-[14px] !h-[14px] leading-none mb-0.5" svgIcon="heroicons_outline:calendar"></mat-icon> {{data.notificacion.createdAt | date:'medium'}}</span>
                <span *ngIf="data.notificacion.ambito" class="bg-gray-100 px-2.5 py-1 rounded-md text-gray-500">{{data.notificacion.ambito}}</span>
            </div>
        </div>

        <div class="px-6 py-4 flex justify-end bg-white border-t border-gray-100/60 rounded-b-2xl">
            <button mat-button color="primary" class="!px-6 !font-bold" (click)="dialogRef.close()">Cerrar</button>
        </div>
    `
})
export class NotificationInboxDetailDialog {
    constructor(
        public dialogRef: MatDialogRef<NotificationInboxDetailDialog>,
        @Inject(MAT_DIALOG_DATA) public data: { notificacion: NotificacionInbox }
    ) { }
}
